import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
  Button,
  IconButton
} from '@mui/material';
import {
  People as PeopleIcon,
  Settings as SettingsIcon,
  ArrowBack as ArrowBackIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import UserManagement from './UserManagement';
import ConfigurationSettings from './ConfigurationSettings';

const Settings = ({ onBack, onLogout, authenticatedUser }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton onClick={onBack} title="Back to Dashboard">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Settings
          </Typography>
        </Box>
        <Button
          variant="outlined"
          startIcon={<LogoutIcon />}
          onClick={onLogout}
        >
          Logout
        </Button>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<PeopleIcon />} label="Users" iconPosition="start" />
          <Tab icon={<SettingsIcon />} label="Configuration" iconPosition="start" />
        </Tabs>
      </Paper>

      <Box>
        {activeTab === 0 && <UserManagement authenticatedUser={authenticatedUser} />}
        {activeTab === 1 && <ConfigurationSettings />}
      </Box>
    </Container>
  );
};

export default Settings;

